import React from "react";
import { useSelector } from "react-redux";

const SlideShareBigIcon = ({ fill }) => {
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="59.019"
      height="59.018"
      viewBox="0 0 59.019 59.018"
    >
      <g id="db39" transform="translate(-191.37 -191.37)">
        <path
          id="Path_1278"
          data-name="Path 1278"
          d="M220.878,191.37a29.509,29.509,0,1,0,29.511,29.508,29.508,29.508,0,0,0-29.511-29.508Zm18.384,32.078a17.252,17.252,0,0,1-6.314,4.492c-.769.337-.89.586-.681,1.4a11.04,11.04,0,0,1-1.2,9.221,7.061,7.061,0,0,1-5.7,3.231,5.123,5.123,0,0,1-1.575-.241,4.026,4.026,0,0,1-2.907-3.082,4.272,4.272,0,0,1-1.011,1.9,4.583,4.583,0,0,1-3.43,1.432,6.046,6.046,0,0,1-1.423-.175,7.568,7.568,0,0,1-5.739-6.751,25.819,25.819,0,0,1,.242-5.686c.095-.7-.028-.853-.647-1.239-1.526-.95-3.027-1.983-4.479-2.983q-.72-.5-1.441-.99a1.346,1.346,0,0,1-.564-.653c-.038-.124-.084-.253-.132-.39a2.933,2.933,0,0,1-.252-1.61c.108-.454.043-.562.707-.7.125-.026.33.216.33.187l-.09-4.528c0-2.964.137-5.984.141-8.947,0-2.846,1.975-4.546,4.782-4.547,8.506,0,17.162,0,25.667,0a4.088,4.088,0,0,1,4.442,4.284c.015,2.814.057,5.676.062,8.442,0,1.594.024,3.188.029,4.78,0,.062.011.149.016.257.118.026.244.051.365.075.661.133,1.184.238,1.29.691a2.681,2.681,0,0,1-.481,2.128Z"
          transform="translate(0 0)"
          fill={fill ? fill : colors.theme}
        />
        <path
          id="Path_1279"
          data-name="Path 1279"
          d="M307.573,281.436a4.637,4.637,0,0,0-.652-.155h-.2c-7.422,0-14.844.117-22.265.12-.238,0-.566.114-1.091.12a4.827,4.827,0,0,0-1.45.029,2.111,2.111,0,0,0-.744.405,2.244,2.244,0,0,0-.607.878,3.679,3.679,0,0,0-.27,1.837v.854c0,3.941-.235,7.427-.18,11.433,0,.208,1.35,1.192,1.554,1.294a17.592,17.592,0,0,0,8.968,1.686c.312-.021.793-.044,1.2-.044a4.9,4.9,0,0,1,3.728,1.342,3.287,3.287,0,0,1,2.91-1.395c.272,0,.591.016.955.05.591.054,1.19.081,1.771.081a18.083,18.083,0,0,0,7.85-1.782,1.241,1.241,0,0,0,.557-.793c.061-4.773.066-9.243.018-13.546-.018-1.585-.478-2.173-2.05-2.414Zm-14.241,15.192a4.981,4.981,0,0,1-3.52,1.438c-.037,0-.074-.006-.11-.008a5.145,5.145,0,1,1,.019-10.289h.037a5.341,5.341,0,0,1,5.041,5.1A5.5,5.5,0,0,1,293.332,296.628Zm12.032.184a5.477,5.477,0,0,1-3.662,1.77h-.066a5.269,5.269,0,0,1-5.126-5.2,5.161,5.161,0,0,1,5.106-4.945,5.091,5.091,0,0,1,5.171,4.931,4.891,4.891,0,0,1-1.422,3.44Z"
          transform="translate(-74.552 -75.541)"
          fill={fill ? fill : colors.theme}
        />
      </g>
    </svg>
  );
};

export default SlideShareBigIcon;
